import * as exElement from '../../../utils/element';

import type { Context } from '../types';

// ----------------------------------------------------------------------------

function dropdown(ctx: Context): any {
    ctx.shared.elements.dropdown = {};

    function init(): void {
        create();
    }

    // ------------------------------------------------------------------------

    function create(): void {
        // Create element (select dropdown)
        const elSelectDropdown = exElement.create({
            merge: ctx.shared.config.dropdown,
            class: {
                new: 'select-dropdown dropdown-menu',
            },
        });
        ctx.shared.elements.element.appendChild(elSelectDropdown);
        ctx.shared.elements.dropdown.element = elSelectDropdown;
    }

    // ------------------------------------------------------------------------

    function positionDropdown(): void {
        const text = ctx.text.getElement();
        const dropdown = ctx.dropdown.getElement();

        const rect = text.getBoundingClientRect();

        dropdown.style.position = 'absolute';
        dropdown.style.top = rect.bottom + window.scrollY + 'px';
        dropdown.style.left = rect.left + window.scrollX + 'px';
        dropdown.style.width = rect.width + 'px';
    }

    // ------------------------------------------------------------------------

    function getElement(): HTMLElement {
        return ctx.shared.elements.dropdown.element;
    }

    // ------------------------------------------------------------------------

    return {
        init,
        create,
        positionDropdown,
        getElement,
    };
}

// ----------------------------------------------------------------------------

export default dropdown;
